export var LOADING_PAUSE_PERCENTAGE = 90;
export var STROKE_WIDTH = 10;
export var WIDTH = 30;
export var LOADING_START_PERCENTAGE = 0;